import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { FormTextareaComponent } from '@pishgamrayan/ng-form-kit';
import * as _ from 'lodash';

@Component({
    selector: 'app-manual-polygon',
    templateUrl: './manual-polygon.component.html',
    imports: [
        CommonModule,
        MatSlideToggleModule,
        TranslateModule,
        FormTextareaComponent,
    ]
})
export class ManualPolygonComponent implements OnInit {
  //#region properties
  @Input() pageVocabs: string;
  @Input() customClass: string = 'sm:tw-w-1/2 md:tw-w-full';
  @Input() isShowMap: boolean;
  @Input() form: FormGroup;

  polygon: any;
  removePolygon: any;
  polygonSample =
    '[[51.632501410374715,32.685432324977654],[51.71922427017287,32.685432324977654],[51.66042911098796,32.64913607398054],[51.632501410374715,32.685432324977654]]';

  @Output('finalPolygon') output_finalPolygon = new EventEmitter<any>();
  @Output('removePolygon') output_removePolygon = new EventEmitter<any>();
  //#endregion

  constructor() {}

  ngOnInit(): void {}

  reversePolygon() {
    if (!this.polygon) return;
    this.removePolygon = this.polygon;
    const polygonArray = JSON.parse(this.polygon);
    let checkForMultiplePolygons = this.checkMultiplePolygons(polygonArray);
    if (checkForMultiplePolygons) {
      let reversedPolygon: any[] = [];
      polygonArray.forEach((polygon) => {
        // Reversing each sub-array
        reversedPolygon.push(
          _.map(polygon, (subArray) => _.reverse([...subArray]))
        );
      });
      this.polygon = JSON.stringify(reversedPolygon);
    } else {
      // Reversing each sub-array
      let reversedPolygon = _.map(polygonArray, (subArray) =>
        _.reverse([...subArray])
      );
      this.polygon = JSON.stringify(reversedPolygon);
    }
    this.emitPolygon();
  }

  //چک میکنه که فقط 1 مختصات هست یا بیشتر
  checkMultiplePolygons(polygons: any[]): boolean {
    return polygons.some(
      (polygon) =>
        Array.isArray(polygon) && polygon.some((item) => Array.isArray(item))
    );
  }

  emitPolygon() {
    this.output_finalPolygon.emit(this.polygon);
    this.output_removePolygon.emit(this.removePolygon);
  }
}
